<template>
  <el-cascader
    v-model="valueBackup"
    :options="list"
    :key="refreshTag"
    :props="{ expandTrigger: 'hover' }"
    @change="handleChange"
    :placeholder="placeholderBackup"
    style="width: 100%"
    :disabled="disabled || (studentId !== 0 && !studentId)"
  >
  </el-cascader>
</template>

<script>
import { index } from '@/api/card-charge-type';

export default {
  props: {
    value: Array,
    storeIds: Array,
    isNew: Boolean,
    disabled: Boolean,
    studentId: {
      type: [Number, String],
      default: 0, // 默认0表示不需要校验学员，非0且为空时认为未选学员
    },
    placeholder: {
      type: String,
      default: '请选择课卡类型',
    },
    emptyPlaceholder: {
      type: String,
      default: '暂无可选课卡类型',
    },
    noStudentPlaceholder: {
      type: String,
      default: '请先选择学员',
    },
  },
  data: () => ({
    valueBackup: [],
    list: [],
    isLoading: true,
    refreshTag: 0,
  }),
  computed: {
    placeholderBackup() {
      if (this.studentId !== 0 && !this.studentId) return this.noStudentPlaceholder;
      if (!this.isLoading && !this.list.length) return this.emptyPlaceholder;
      return this.placeholder;
    },
  },
  watch: {
    value(value) {
      if (JSON.stringify(value) === JSON.stringify(this.valueBackup)) return;
      this.valueBackup = value;
    },
    valueBackup(valueBackup) {
      if (JSON.stringify(valueBackup) === JSON.stringify(this.value)) return;
      this.$emit('input', valueBackup);
    },
    storeIds(storeIds) {
      this.getList(storeIds);
    },
    isNew() {
      this.getList(this.storeIds);
    },
  },
  methods: {
    async getList(store_ids) {
      if (this.refreshTag) {
        this.list = [];
      }
      this.refreshTag++;

      this.isLoading = true;
      const { isError, data } = await index({
        store_ids,
        is_with_card_type: 1,
        is_new: this.isNew ? 1 : 0,
      });
      this.isLoading = false;
      if (!isError) this.list = data;
    },
    handleChange(valueBackup) {
      this.$emit('change', valueBackup);
    },
  },
  beforeMount() {
    this.valueBackup = this.value || [];
    this.getList(this.storeIds);
  },
};
</script>
